"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _antd = require("antd");

var _icons = require("@ant-design/icons");

var _utils = _interopRequireDefault(require("../../../../../utils"));

var _reactCsv = require("react-csv");

// import { useHistory } from 'react-router';
var TableData = function TableData(_ref) {
  var MoreData = _ref.MoreData;
  var date = new Date();
  var today = "".concat(date.getFullYear(), "-").concat(date.getMonth() + 1, "-").concat(date.getDate());
  var time = "".concat(date.getHours(), ":").concat(date.getMinutes());
  var header = [{
    label: "Token_no",
    key: "Token_no"
  }, {
    label: "auditdate",
    key: "auditdate"
  }, {
    label: "RM_code",
    key: "RM_code"
  }, {
    label: "send_sheets",
    key: "send_sheets"
  }, {
    label: "RM_give_correct_marks",
    key: "RM_give_correct_marks"
  }, {
    label: "RM_Send_mark_in_evening",
    key: "RM_Send_mark_in_evening"
  }];
  var csvRport = {
    filename: "Audit Data " + MoreData[0].RM_code + " " + today + " " + time,
    headers: header,
    data: MoreData
  }; // const history = useHistory();
  // const cl = localStorage.getItem("CL");
  // const token = localStorage.getItem("token");

  var _useState = (0, _react.useState)(true),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0, _react.useState)(MoreData),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      tableData = _useState4[0],
      setTableData = _useState4[1];

  var _useState5 = (0, _react.useState)(MoreData),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      alltableData = _useState6[0],
      setallTableData = _useState6[1];

  var columns = [{
    title: "RM Code",
    dataIndex: "RM_code",
    key: "RM_code",
    fixed: "left",
    sorter: function sorter(a, b) {
      return _utils.default.antdTableSorter(a, b, 'RM_code');
    }
  }, {
    title: "Token_no",
    dataIndex: "Token_no",
    key: "Token_no",
    fixed: "left",
    sorter: function sorter(a, b) {
      return _utils.default.antdTableSorter(a, b, 'Token_no');
    }
  }, {
    title: "Date",
    dataIndex: "auditdate",
    key: "daauditdatete",
    fixed: "left",
    sorter: function sorter(a, b) {
      return _utils.default.antdTableSorter(a, b, 'auditdate');
    }
  }, {
    title: "RM Sent Sheets?",
    dataIndex: "send_sheets",
    key: "send_sheets",
    fixed: "left",
    render: function render(_, record) {
      return record.send_sheets === "1" || record.send_sheets === 'हाँ' ? "Yes" : record.send_sheets === "3" || record.send_sheets === 'No रिस्पोंस फ़ोर्म' ? "No Response" : "No";
    },
    sorter: function sorter(a, b) {
      return _utils.default.antdTableSorter(a, b, 'send_sheets');
    }
  }, {
    title: "RM give correct marks?",
    dataIndex: "RM_give_correct_marks",
    key: "RM_give_correct_marks",
    fixed: "left",
    render: function render(_, record) {
      return record.RM_give_correct_marks === "1" || record.RM_give_correct_marks === 'हाँ' || record.RM_give_correct_marks === '1-3 मार्क्स की गलती है' ? "Yes" : record.RM_give_correct_marks === "3" || record.RM_give_correct_marks === 'No रिस्पोंस फ़ोर्म' ? "No Response" : "No";
    },
    sorter: function sorter(a, b) {
      return _utils.default.antdTableSorter(a, b, 'RM_give_correct_marks');
    }
  }, {
    title: "RM Send marks in evening?",
    dataIndex: "RM_Send_mark_in_evening",
    key: "RM_Send_mark_in_evening",
    fixed: "left",
    render: function render(_, record) {
      return record.RM_Send_mark_in_evening === "1" || record.RM_Send_mark_in_evening === 'हाँ' ? "Yes" : record.RM_Send_mark_in_evening === "3" || record.RM_Send_mark_in_evening === 'No रिस्पोंस फ़ोर्म' ? "No Response" : "No";
    },
    sorter: function sorter(a, b) {
      return _utils.default.antdTableSorter(a, b, 'RM_Send_mark_in_evening');
    }
  }]; // useEffect(async () => {
  //   setTableData(MoreData);
  //   setallTableData(MoreData);
  //   setLoading(false)
  // }, [MoreData]);

  (0, _react.useEffect)(function () {
    function fetchData() {
      return _fetchData.apply(this, arguments);
    }

    function _fetchData() {
      _fetchData = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                setTableData(MoreData);
                setallTableData(MoreData);
                setLoading(false);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _fetchData.apply(this, arguments);
    }

    fetchData(); // eslint-disable-next-line 
  }, [MoreData]);

  var onSearch = function onSearch(e) {
    var value = e.currentTarget.value;

    var searchdata = _utils.default.wildCardSearch(alltableData, value);

    setTableData(searchdata);
  };

  return loading ? /*#__PURE__*/_react.default.createElement(_antd.Spin, {
    tip: "Loading..."
  }) : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_antd.Input, {
    placeholder: "Search",
    style: {
      width: '40%'
    },
    prefix: /*#__PURE__*/_react.default.createElement(_icons.SearchOutlined, null),
    onChange: function onChange(e) {
      return onSearch(e);
    },
    className: "m-2"
  }), /*#__PURE__*/_react.default.createElement(_antd.Card, {
    extra: /*#__PURE__*/_react.default.createElement(_reactCsv.CSVLink, csvRport, /*#__PURE__*/_react.default.createElement(_icons.DownloadOutlined, {
      style: {
        'fontSize': 30
      }
    }))
  }, /*#__PURE__*/_react.default.createElement(_antd.Table, {
    columns: columns,
    dataSource: tableData,
    rowKey: "Token_no",
    scroll: {
      y: 300
    },
    pagination: false
  })));
};

var _default = TableData;
exports.default = _default;